import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  count: number = 0;
  timeout: any;

  constructor() { }

  control() {
    if (++this.count !== 10) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.count = 0;
      }, 3000);

      return;
    }

    alert('Браузер зациклился, пожалуйста войдите в свой аккаунт снова');
    this.count = 0;
    return ['502'];
  }
}
